import { Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import styles from '../../../assets/styles/componentStyles/carouselCard.module.scss'

export const ImageCardCarousel = (props: any) => {
    const { image, handleMouseDown, handleMouseUp } = props;

    return (
        <Grid container>
            <Grid item xs={12} sx={{ padding: '5px' }}>
                <Grid container>
                    <Grid item xs={12} className={styles.chat_crl_img_item}>
                        {/* <LazyLoad style={{ height: "100%", width: "100%" }}> */}
                        <img
                            onMouseDown={handleMouseDown}
                            onMouseUp={(event) => handleMouseUp(event, image)}
                            src={image.image_url || "https://storage.googleapis.com/storage.writewiz-staging.in/chronox/general/medical_(3)_1726065948494.png"}
                            alt=""
                            style={{ borderRadius: "5px", cursor: "pointer", width: '100%', height: '100%', maxHeight: '100%', objectFit: "cover", objectPosition: "center" }}
                        />
                        {/* </LazyLoad> */}
                    </Grid>

                    {image.additional_information &&
                        <Grid item xs={12} sx={{ margin: '10px 0px', padding: '0px 4px', width: "100%" }}>
                            <Grid container direction={"column"} alignItems={"center"}>
                                <Typography
                                    component="span"
                                    className={styles.chat_crl_img_caption_text}
                                    sx={{ fontSize: "15px !important", fontWeight: "500 !important" }}
                                >
                                    {String(Object.values(image.additional_information)[0])}
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}
